import React, {FormEvent, useCallback, useEffect, useMemo, useRef, useState} from "react";
import FlexContainer from "../components/FlexContainer";
import TitleHeading from "../components/TitleHeading";
import Input from "../components/Input";
import Button, {ButtonColor, ButtonVariant} from "../components/Button";
import useDebounce from "../hooks/useDebounce";
import styled from "styled-components";
import Container, {ContainerProps} from "../components/Container";
import {AppContainer} from "../App";
import {getSheetHistory, getSheetInfo, startParse, WorkProgressHistoryInterface, WorkProgressInterface} from "../http";
import moment from "moment";
import "moment/locale/ru"
const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const MainPage: React.FunctionComponent = () => {

    const [subdomain, setSubdomain] = useState<string>("")
    const [email, setEmail] = useState<string>("")
    const [apikey, setApiKey] = useState<string>("")
    const [googleId, setGoogleId] = useState<string>("")
    const timer = useRef<any | null>(null)
    const timer2 = useRef<any | null>(null)


    const [item, setItem] = useState<WorkProgressInterface|undefined>(undefined)
    const [error, setError] = useState<string>("")
    const [disableButton, setDisableButton] = useState<boolean>(false)

    const isButtonDisabled = useMemo(() => {
        return disableButton || (!!item) || (subdomain.length === 0 || email.length === 0 || apikey.length === 0 || googleId.length === 0)
    }, [disableButton, item, subdomain, email, apikey, googleId])


     useDebounce(() => {
         if (timer.current) {
             clearInterval(timer.current)
         }
         if (timer2.current) {
             clearInterval(timer2.current)
         }

         if (subdomain.length > 2) {
             timer.current = setInterval(() => {
                 getSheetInfo(subdomain).then((response) => {
                     setItem(response.data.item)
                 })
             }, 500)
         }


    }, 500, [subdomain])

    useEffect(() => {
        setSubdomain(localStorage.getItem("subdomain") ?? "")
        setEmail(localStorage.getItem("email") ?? "")
        setApiKey(localStorage.getItem("apikey") ?? "")
        setGoogleId(localStorage.getItem("googleId") ?? "")
    }, [])

    const onSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        localStorage.setItem("subdomain", subdomain)
        localStorage.setItem("email", email)
        localStorage.setItem("apikey", apikey)
        localStorage.setItem("googleId", googleId)

        setError("")

        setDisableButton(true)

        startParse({
            subdomain,
            email,
            apiKey: apikey,
            googleId
        }).then(() => setTimeout(() => {setDisableButton(false)}, 3000)).catch((e) => {
            setError(e.response.data.errors[0].message)
            setDisableButton(false)
        })

    }, [subdomain, email, apikey, googleId])

    return <StyledForm onSubmit={onSubmit}>
        <FlexContainer>
            <TitleHeading>Введите данные от аккаунта</TitleHeading>
        </FlexContainer>
        <FlexContainer flexDirection={"column"} gap={10}>
            <FlexContainer gap={30}>
                <label htmlFor={"subdomain"} style={{width: 100}}>Субдомен</label>
                <div>
                    <Input
                        style={{width: 400}}
                        id={"subdomain"}
                        name={"subdomain"}
                        type={"text"}
                        placeholder={"Ваш домен (https:// и amocrm.ru не нужно)"}
                        value={subdomain}
                        onChange={(e) => setSubdomain(e.target.value.trimStart())}
                    />
                </div>
            </FlexContainer>
            <FlexContainer gap={30}>
                <label htmlFor={"email"} style={{width: 100}}>E-mail</label>
                <div>
                    <Input
                        style={{width: 400}}
                        id={"email"}
                        name={"email"}
                        type={"email"}
                        placeholder={"admin@mail.com"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value.trimStart())}
                    />
                </div>
            </FlexContainer>
            <FlexContainer gap={30}>
                <label htmlFor={"apikey"} style={{width: 100}}>API ключ</label>
                <div>
                    <Input
                        style={{width: 400}}
                        id={"apikey"}
                        name={"apikey"}
                        type={"text"}
                        placeholder={"API ключ из профиля"}
                        value={apikey}
                        onChange={(e) => setApiKey(e.target.value.trimStart())}
                    />
                </div>
            </FlexContainer>
            <FlexContainer gap={30}>
                <label htmlFor={"google_id"} style={{width: 100}}>Google ID</label>
                <div>
                    <Input
                        style={{width: 400}}
                        id={"google_id"}
                        name={"google_id"}
                        type={"text"}
                        placeholder={"1hstvXg1TQBdOLQKRga_h-QYc1ON4Ur4E_1wb0-v_JXg"}
                        value={googleId}
                        onChange={(e) => setGoogleId(e.target.value.trimStart())}
                    />
                </div>
            </FlexContainer>
        </FlexContainer>
        <FlexContainer>
            <Button
                type={"submit"}
                style={{width: 300}}
                disabled={isButtonDisabled}
                variant={ButtonVariant.CONTAINED}
                color={ButtonColor.PRIMARY}>
                Начать
            </Button>
        </FlexContainer>
        {error && <FlexContainer>
            <span style={{color: "red"}}>{error}</span>
        </FlexContainer>}

        {item &&
            <FlexContainer flexDirection={"column"}>
                <div>
                    <span>Идет парсинг...</span> <br/>
                    <span>Всего строк: {item.rowCount}</span><br/>
                    <span>Пройдено успешно строк: {item.passCount}</span><br/>
                    <span>Дата начала: {moment(item.startedAt * 1000).calendar()}</span><br/>
                </div>
            </FlexContainer>
        }
    </StyledForm>

}

export default MainPage